export default __webpack_public_path__ + "static/media/creative-mob.25e81412.png";